export default {
	text: "{changedBy} commented on KR <a href='#' data-action='key-result'>{name}</a>.",
};
